import axios from "axios";
import Swal from 'sweetalert2'
import  filtrarDocumento from "./utils/filtrarpordocumento";
export default {
    state:{
        itemsinfiltrar:[],
        allitems:[],
    },
    mutations:{
        setAllItems(state,items){
            state.allitems=items
            state.itemsinfiltrar = items
        },
        setDocumentosFiltrados(state,itemfiltrados){
            //Guardamos los items sin filtrar
            

            //Asignamos los items filtrados
            state.allitems=itemfiltrados

        }
    },
    actions:{
        async setAllVentas({commit,rootState,getters}){
           await axios.get(`${rootState.urlapi}/facturas`,getters.getTokenUser).then(res=>{
                commit("setAllItems",res.data)
              }).catch(err=>{console.error(err)});
        },

        async setAllCreditos({commit,rootState,getters}){
            await axios.get(`${rootState.urlapi}/facturas/creditos`,getters.getTokenUser).then(res=>{
                 commit("setAllItems",res.data)
               }).catch(err=>{console.error(err)});
         },

        async setVentasPorFecha({commit,rootState,getters},params){
            try {
                console.log(params)
                const {data} = await axios.get(`${rootState.urlapi}/facturas/ventasporfecha?${params}`,getters.getTokenUser);
                commit("setAllItems",data)
               // Swal.fire('Consulta Realizada','','success',{showConfirmButton: false,timer:1500})
              } catch (error) {
                console.log(error)
                Swal.fire('Erro al realizar consulta',error.message,'error')
              }
         },
        async createVenta({rootState,getters},item){
            item.idusuario = getters.usuarioAuth.usuario.idusuario
            const data = await axios.post(`${rootState.urlapi}/facturas`,item,getters.getTokenUser)
            return data
        },

        async enviarCorreo({getters},item){
            const {data} = await axios.post(`${getters.getUrlPdf}/email/`,{"datos":item})
            if(data.error){
              Swal.fire(data.msg,data.error,'error')
            }else{
              Swal.fire(data.msg,'','success')
            }
        },
        async generarPdf({getters},item){
            
            try {
                const {data } = await axios.get(`${getters.getUrlApi}/facturadetalles/${item.idfactura}`)
                item.productos = data
                await axios.post(`${getters.getUrlPdf}/${item.size}/`,{"datos":item})
            } catch (error) {
                console.log(error)
            }
        },

        //Metodos para Filtrar Ventas
        filtrarArchivos({commit,state},tipo){
          const items = filtrarDocumento(state.itemsinfiltrar,tipo)
          commit("setDocumentosFiltrados",items)
        }
    },
    getters:{
        getAllVentas(state){
            return state.allitems
        },
    }
}